import { useTableFilter } from "@/shared";
import { GeneralTable } from "@/shared/components/ui";
import {
  Grid,
  MenuItem,
  Box,
  Button,
  Alert,
  Typography,
  CircularProgress,
  Dialog,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Select,
  Checkbox,
  ListItemText,
  FormControl,
  InputLabel,
  TextField,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useRef, useMemo, useState, useEffect } from "react";
import Flatpickr from "react-flatpickr";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { Description, PictureAsPdf, Search, SearchOutlined } from "@mui/icons-material";
import { useObtenerReporteComisiones } from "@/shared/actions/erp/reporte-comisiones-vendedores.actions";
import { useTableColumnsReporteComisiones } from "@/shared/hooks/useTableColumnsComisionesVendedores";
import { format } from "date-fns";
import { exportToExcel, ExportColumn } from "../utils/exportUtils";
// import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import MonthPicker from "@/shared/components/ui/CustomSearch/MonthPicker";
import "flatpickr/dist/plugins/monthSelect/style.css";
import { useObtenerGruposCargosAsignados, useObtenerEmpleadosYPrincipalComision, useProcesarReporteComision } from "@/shared/actions/erp/reporte-comisiones-vendedores.actions";

interface GrupoVendedor {
  grupo_id: string;
  grupo: string;
  cargo: string;
  cargos_ids: string;
  nombre_empleado: string;
}

export default function TableReporteVendedoresExternos() {
  // Buscador para vendedores
  const [searchVendedor, setSearchVendedor] = useState("");
  // Estado para empleados del grupo seleccionado
  const [empleadosGrupo, setEmpleadosGrupo] = useState<any[]>([]);
  const [isLoadingEmpleados, setIsLoadingEmpleados] = useState(false);
  const {
    dateBefore,
    dateAfter,
    onChangeRangeDate,
    cleanFilter,
  } = useTableFilter();

  // Estado de filtros
  const [grupoVendedorOptions, setGrupoVendedorOptions] = useState<GrupoVendedor[]>([]);
  const [planFilter, setPlanFilter] = useState<string[]>([]); // stores grupo_id

  // Hook para obtener grupos cargos asignados
  const obtenerGruposCargosAsignadosMutation = useObtenerGruposCargosAsignados();
  const isLoadingGrupos = obtenerGruposCargosAsignadosMutation.isPending;
  const errorGrupos = obtenerGruposCargosAsignadosMutation.error;

  // Hook para obtener empleados y principal comisión
  const obtenerEmpleadosYPrincipalComisionMutation = useObtenerEmpleadosYPrincipalComision();

  // Función para obtener empleados del grupo seleccionado usando el hook
  const fetchEmpleadosGrupo = async (cargosIds: string, fechaHasta: string) => {
    setIsLoadingEmpleados(true);
    try {
      const response = await obtenerEmpleadosYPrincipalComisionMutation.mutateAsync({ cargos_ids: cargosIds, fecha_hasta: fechaHasta });
      if (Array.isArray(response)) {
        setEmpleadosGrupo(response);
      } else if (response?.data && Array.isArray(response.data)) {
        setEmpleadosGrupo(response.data);
      } else {
        setEmpleadosGrupo([]);
      }
    } catch (err: any) {
      setEmpleadosGrupo([]);
    } finally {
      setIsLoadingEmpleados(false);
    }
  };
  // Estado de búsqueda en grupo vendedor
  const [searchGrupo, setSearchGrupo] = useState<string>("");
  // Obtener grupos cargos asignados usando el hook
  useEffect(() => {
    const fetchGrupos = async () => {
      try {
        const response = await obtenerGruposCargosAsignadosMutation.mutateAsync({});
        if (Array.isArray(response)) {
          setGrupoVendedorOptions(response);
        } else if (response?.data && Array.isArray(response.data)) {
          setGrupoVendedorOptions(response.data);
        }
      } catch (err) {
        setGrupoVendedorOptions([]);
      }
    };
    fetchGrupos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const [canalFilter, setCanalFilter] = useState<string[]>([]);

  // Estado para filtro de tipo de registro (Activos/Pendientes)
  const [estadoRegistroFilter, setEstadoRegistroFilter] = useState<string>("todos");

  // Estados para búsqueda en selector de canal y plan
  const flatpickrHastaRef = useRef<Flatpickr | null>(null);

  // Estados de datos y carga
  const [allData, setAllData] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [, setError] = useState<string>("");
  const [dateRangeError, setDateRangeError] = useState<string>("");

  // Estados para modal de exportación
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [exportType, setExportType] = useState<"excel" | "pdf" | "">("");
  const [exportProgress, setExportProgress] = useState<number>(0);

  // Estado para datos de resumen del vendedor
  const [resumenVendedor, setResumenVendedor] = useState<{
    nombre_vendedor: string;
    ventas: number;
    ventas_pendientes: number;
    total_comisiones: number;
    comision_mes_anterior: number;
    equifax: number;
    charvag: number;
    total_pagar: number;
  } | null>(null);

  const [datosMeses, setDatosMeses] = useState<any[]>([]);

  // Estado para detalles de charvag
  const [detallesCharvag, setDetallesCharvag] = useState<any[]>([]);

  // Estados para datos de procesamiento/JSON
  const [datosContratosActivos, setDatosContratosActivos] = useState<any[]>([]);
  const [datosPendientes, setDatosPendientes] = useState<any[]>([]);
  const [datosCharvagg, setDatosCharvagg] = useState<any[]>([]);
  const [idEmpProcesa, setIdEmpProcesa] = useState<number>(0);
  const [mesProcesa, setMesProcesa] = useState<number>(0);
  const [anioProcesa, setAnioProcesa] = useState<number>(0);
  const [idUsuarioProcesa, setIdUsuarioProcesa] = useState<number>(0);

  // Estado para modal de chargeback
  const [openChargebackModal, setOpenChargebackModal] = useState<boolean>(false);

  // Estado para verificar si los datos ya fueron procesados
  const [datosYaProcesados, setDatosYaProcesados] = useState<boolean>(false);

  // Estado para checkbox de confirmación
  const [confirmarProcesamiento, setConfirmarProcesamiento] = useState<boolean>(false);

  // Estado para mostrar mensajes de notificación
  const [notificacion, setNotificacion] = useState<{ tipo: 'success' | 'error'; mensaje: string } | null>(null);

  const [mesDesde, setMesDesde] = useState<string>("");
  const [mesHasta, setMesHasta] = useState<string>("");

  // Seleccionar automáticamente el mes actual al iniciar
  useEffect(() => {
    // Solo si no hay mes seleccionado
    if (!mesDesde) {
      const now = new Date();
      // yyyy-MM-26 para el día fijo del input "Desde"
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const mesActual = `${year}-${month}-26`;
      setMesDesde(mesActual);
      // Calcular automáticamente el siguiente mes para "Hasta"
      const siguienteMes = getNextMonth(mesActual);
      setMesHasta(siguienteMes);
    }
  }, []);

  // Paginación para Material React Table (manejada internamente por la tabla)
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const getNextMonth = (dateStr: string) => {
    const d = new Date(dateStr);
    d.setMonth(d.getMonth() + 1);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const toMonthDate = (fullDate: string) => {
    const d = new Date(fullDate);
    // importante: normalizar al día 1 porque monthSelect ignora el día
    d.setDate(1);
    return d;
  };

  // Calcular fechas del mes anterior
  const { firstDayPrevMonth, lastDayPrevMonth } = useMemo(() => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth(); // 0-11

    // Primer día del mes anterior
    const firstDay = new Date(year, month - 1, 1);

    // Último día del mes anterior (día 0 del mes actual)
    const lastDay = new Date(year, month, 0);

    return {
      firstDayPrevMonth: format(firstDay, "yyyy-MM-dd"),
      lastDayPrevMonth: format(lastDay, "yyyy-MM-dd")
    };
  }, []);


  // Cargar datos al montar (con rango del mes anterior)
  useEffect(() => {
    if (!dateAfter && !dateBefore) {
      // Establecer rango del mes anterior por defecto
      const startDate = new Date(firstDayPrevMonth);
      const endDate = new Date(lastDayPrevMonth);
      onChangeRangeDate([startDate, endDate]);
    }
  }, []);

  useEffect(() => {
    if (mesHasta && flatpickrHastaRef.current) {
      const dateObj = toMonthDate(mesHasta);

      flatpickrHastaRef.current.flatpickr.setDate(dateObj, true);

      console.log("ACTUALIZANDO INPUT HASTA:", dateObj);
    }
  }, [mesHasta]);

  // Validar rango de fechas
  useEffect(() => {
    if (!dateAfter || !dateBefore) {
      setDateRangeError("");
      return;
    }

    const fechaDesde = new Date(dateAfter);
    const fechaHasta = new Date(dateBefore);
    const diffDays = Math.ceil((fechaHasta.getTime() - fechaDesde.getTime()) / (1000 * 60 * 60 * 24)) + 1;

    if (diffDays > 31) {
      setDateRangeError(`El rango seleccionado es de ${diffDays} días. Solo se permiten hasta 31 días.`);
      setAllData([]);
      return;
    } else {
      setDateRangeError("");
    }
  }, [dateAfter, dateBefore]);

  // Cargar datos cuando cambian los filtros (con debounce) - DESHABILITADO
  // useEffect(() => {
  //   if (!dateAfter || !dateBefore || dateRangeError || !hasUserInteracted) return;

  //   const timeoutId = setTimeout(() => {
  //     loadData();
  //   }, 500); // Debounce de 500ms

  //   return () => clearTimeout(timeoutId);
  // }, [dateAfter, dateBefore, vendedor, dateRangeError, hasUserInteracted]);

  const { columnBase } = useTableColumnsReporteComisiones({ pagination });
  const flatpickrMonthRef = useRef(null);


  // Filtrar grupos por búsqueda
  const gruposFiltrados = useMemo(() => {
    if (!searchGrupo) return grupoVendedorOptions;
    return grupoVendedorOptions.filter((grupo) =>
      grupo.grupo.toLowerCase().includes(searchGrupo.toLowerCase())
    );
  }, [grupoVendedorOptions, searchGrupo]);

  // Contar registros por estado
  const conteoEstados = useMemo(() => {
    const activos = allData.filter(item => item.estado_registro === 'Activo').length;
    const pendientes = allData.filter(item => item.estado_registro === 'Pendiente').length;
    return { activos, pendientes };
  }, [allData]);

  // Filtrar y ordenar datos - Activos primero, luego Pendientes
  const filteredData = useMemo(() => {
    let data = allData;

    // Filtrar por estado de registro si está seleccionado
    if (estadoRegistroFilter !== "todos") {
      data = data.filter(item => item.estado_registro === estadoRegistroFilter);
    }

    // Ordenar: Activo primero, Pendiente después
    return [...data].sort((a, b) => {
      if (a.estado_registro === 'Activo' && b.estado_registro === 'Pendiente') return -1;
      if (a.estado_registro === 'Pendiente' && b.estado_registro === 'Activo') return 1;
      return 0;
    });
  }, [allData, estadoRegistroFilter]);

  // Función para colorear filas según estado
  const getRowBackgroundColor = (row: any): string => {
    if (row.estado_registro === 'Activo') {
      return 'rgba(76, 175, 80, 0.08)'; // Verde claro
    }
    if (row.estado_registro === 'Pendiente') {
      return 'rgba(255, 152, 0, 0.08)'; // Naranja claro
    }
    return '';
  };

  const exportFilters = useMemo(() => {
    const filters: Record<string, string> = {};

    if (dateAfter && dateBefore) {
      filters["Rango de fechas"] = `${dateAfter} al ${dateBefore}`;
    }

    if (canalFilter.length > 0) {
      filters["Canales"] = canalFilter.join(", ");
    }

    if (planFilter.length > 0) {
      filters["Tipo de plan"] = planFilter.join(", ");
    }

    return filters;
  }, [
    dateAfter,
    dateBefore,
    canalFilter,
    planFilter,
  ]);

  // Paginación en memoria optimizada - solo pasamos las filas visibles a la tabla
  // Esto mejora drásticamente el rendimiento porque GeneralTable solo renderiza 10-50 filas en vez de 4812
  const paginatedData = useMemo(() => {
    const startIdx = pagination.pageIndex * pagination.pageSize;
    const endIdx = startIdx + pagination.pageSize;
    return filteredData.slice(startIdx, endIdx);
  }, [filteredData, pagination.pageIndex, pagination.pageSize]);

  const handleCleanFilter = () => {
    setPlanFilter([]);
    setCanalFilter([]);
    setEstadoRegistroFilter("todos");
    cleanFilter();
    setResumenVendedor(null);
    setDatosMeses([]);
    setDetallesCharvag([]);
    setDatosContratosActivos([]);
    setDatosPendientes([]);
    setDatosCharvagg([]);
    setAllData([]);
    setOpenChargebackModal(false);
    setDatosYaProcesados(false);
    setConfirmarProcesamiento(false);

    // Restablecer rango del mes anterior
    const startDate = new Date(firstDayPrevMonth);
    const endDate = new Date(lastDayPrevMonth);
    onChangeRangeDate([startDate, endDate]);
  };

  const obtenerReporteComisionesMutation = useObtenerReporteComisiones();
  const procesarReporteComisionMutation = useProcesarReporteComision();
  const handleSearch = async () => {
    try {
      setIsLoading(true);
      setError("");

      // Validar que estén seleccionados grupo y vendedor
      if (!planFilter[0]) {
        setError("Por favor, selecciona un Grupo Vendedor");
        setIsLoading(false);
        return;
      }

      if (!canalFilter[0]) {
        setError("Por favor, selecciona un Vendedor");
        setIsLoading(false);
        return;
      }

      // Obtener valores seleccionados
      const grupoId = planFilter[0];
      const grupo = grupoVendedorOptions.find(g => g.grupo_id === grupoId);
      const cargosId = grupo?.cargos_ids || "";
      const vendedorId = canalFilter[0];
      const vendedorObj = empleadosGrupo.find(e => String(e.id_emp) === vendedorId);
      const esPrincipal = vendedorObj?.es_principal === 1 ? 1 : 0;

      // Extraer YYYY-MM del string mesDesde y mesHasta
      const getYearMonth = (dateStr: string) => {
        if (!dateStr) return "";
        const [year, month] = dateStr.split("-");
        return `${year}-${month}`;
      };

      const payload = {
        fecha_1: getYearMonth(mesDesde),
        fecha_inicio: mesDesde,
        fecha_2: getYearMonth(mesHasta),
        fecha_fin: mesHasta,
        cargos_id: cargosId,
        grupo_id: grupoId,
        vendedor: vendedorId,
        es_principal: esPrincipal,
      };

      const response = await obtenerReporteComisionesMutation.mutateAsync(payload);
      // Extraer el array de activos de la respuesta del reporte de comisiones
      const responseData = response as any;
      const activos = responseData?.data?.activos || [];

      // Extraer datos_meses
      const datosMesesData = responseData?.data?.datos_meses || [];
      setDatosMeses(datosMesesData);

      // Verificar si los datos ya fueron procesados
      const procesoDatos = responseData?.data?.proceso_datos;
      setDatosYaProcesados(procesoDatos === "SI");

      // Extraer detalles de chargeback desde data (puede venir en charvag o detalles_charvarg)
      const detallesCharvagData = responseData?.data?.detalles_charvarg || [];
      console.log('Detalles Chargeback:', detallesCharvagData);
      setDetallesCharvag(detallesCharvagData);
      setDatosCharvagg(detallesCharvagData);

      // Extraer datos de resumen del primer vendedor activo
      if (activos.length > 0) {
        const vendedorData = activos[0];
        setResumenVendedor({
          nombre_vendedor: vendedorData.nombre_vendedor || '-',
          ventas: vendedorData.ventas || 0,
          ventas_pendientes: vendedorData.ventas_pendientes || 0,
          total_comisiones: vendedorData.total_comisiones || 0,
          comision_mes_anterior: vendedorData.comision_mes_anterior || 0,
          equifax: vendedorData.equifax || 0,
          charvag: vendedorData.charvag || 0,
          total_pagar: vendedorData.total_pagar || 0,
        });
      } else {
        setResumenVendedor(null);
      }

      // Extraer todas las ventas (datos_ventas y datos_ventas_pendientes) de todos los activos
      const todasLasVentas: any[] = [];
      const contratosActivos: any[] = [];
      const pendientesArray: any[] = [];

      activos.forEach((activo: any) => {
        // Agregar ventas activas con estado "Activo"
        if (activo.datos_ventas && Array.isArray(activo.datos_ventas)) {
          activo.datos_ventas.forEach((venta: any) => {
            todasLasVentas.push({ ...venta, estado_registro: 'Activo' });
            contratosActivos.push(venta);
          });
        }
        // Agregar ventas pendientes con estado "Pendiente"
        if (activo.datos_ventas_pendientes && Array.isArray(activo.datos_ventas_pendientes)) {
          activo.datos_ventas_pendientes.forEach((venta: any) => {
            todasLasVentas.push({ ...venta, estado_registro: 'Pendiente' });
            pendientesArray.push(venta);
          });
        }
      });

      // Guardar datos de contratos y pendientes
      setDatosContratosActivos(contratosActivos);
      setDatosPendientes(pendientesArray);

      // Extraer id_emp_procesa del primer vendedor
      if (vendedorObj?.id_emp) {
        setIdEmpProcesa(parseInt(String(vendedorObj.id_emp)));
      }
      // Usar el mes y año del filtro (del "Hasta")
      const mesNum = parseInt(mesHasta.split('-')[1]);
      const anioNum = parseInt(mesHasta.split('-')[0]);
      setMesProcesa(mesNum);
      setAnioProcesa(anioNum);
      setIdUsuarioProcesa(521); // ID de usuario quemado

      // Mapear los datos de ventas a la estructura de las columnas existentes
      const mappedData = todasLasVentas.map((venta: any) => ({
        estado_registro: venta.estado_registro || '-',           // Estado del registro (Activo/Pendiente)
        tipo: venta.vendedor || '-',                           // Vendedor
        vendedor: venta.perfil || '-',                         // Perfil Vendedor
        cargo: '-',                                            // Grupo de Ventas
        fecha: venta.fecha_instalacion || '-',                 // Fecha Instalación
        nombre_cliente: venta.fecha_subida || '-',             // Subido el Contrato
        ciudad: String(venta.idContrato || '-'),               // No. Contrato
        sector: venta.nombre_cliente || '-',                   // Cliente
        coordenadas: venta.num_documento || '-',               // # Documento
        tecnico: venta.sector || '-',                          // Sector
        forma_pago: venta.forma_pago || '-',                   // Forma Pago
        Banco: venta.calificacion_buro || '-',                 // Buró de Crédito
        estado_venta: venta.ciudad || '-',                     // Ciudad
        estado_instalacion: venta.nombre_plan || '-',          // Plan
        nombre_plan_factura: venta.valor || '-',               // Costo sin IVA/SEGURO
        nombre_plan: venta.tipo_servicio || '-',               // Servicio
        tipo_plan: venta.descripcion || '-',                   // Estado Cliente
        valor_mensual: venta.porcentaje_comision || '-',       // Porcentaje Comisión
        valor_instalacion: venta.valor || 0,                   // Valor
      }));

      setAllData(mappedData);
    } catch (err) {
      setError("Error al consultar reporte de comisiones");
      setResumenVendedor(null);
      setDetallesCharvag([]);
    } finally {
      setIsLoading(false);
    }
  };

  // Función para generar JSON de procesamiento
  const generarJsonProcesamiento = () => {
    // Construcción de contratos (combinación de activos y pendientes)
    const todosLosContratos = [...datosContratosActivos, ...datosPendientes];
    
    // Contratos a actualizar (sólo con idContrato y porcentaje)
    const contratosActualizar = todosLosContratos.map(c => ({
      idContrato: c.idContrato,
      porcentaje: parseFloat(c.porcentaje_comision || c.porcentaje || '0')
    }));

    // Pendientes indexados
    const pendientesContador = datosPendientes.map((_, i) => i);
    const pendientesIdContrato = datosPendientes.map(p => p.idContrato);
    const pendientesIdEmp = datosPendientes.map(p => p.id_emp);
    const pendientesMes = datosPendientes.map(p => p.mes);
    const pendientesAnio = datosPendientes.map(p => p.anio);
    const pendientesIdEstadoContrato = datosPendientes.map(p => p.idEstado_Contrato);
    const pendientesPorcentajeComision = datosPendientes.map(p => parseFloat(p.porcentaje_comision || '0'));
    const pendientesValorMensual = datosPendientes.map(p => parseFloat(p.valor_mensual || '0'));

    // Chargeback indexados
    const charvaggContador = datosCharvagg.map((_, i) => i);
    const charvaggIdContrato = datosCharvagg.map(c => c.idContrato);
    const charvaggIdEmp = datosCharvagg.map(c => c.id_emp);
    const charvaggMes = datosCharvagg.map(c => c.mes);
    const charvaggAnio = datosCharvagg.map(c => c.anio);
    const charvaggIdEstadoContrato = datosCharvagg.map(c => c.idEstado_Contrato);
    const charvaggValorMensual = datosCharvagg.map(c => parseFloat(c.valor_mensual || '0'));

    const jsonProcesamiento = {
      // DATOS DE PROCESAMIENTO (historial)
      id_emp_procesa: idEmpProcesa,
      mes_procesa: mesProcesa,
      anio_procesa: anioProcesa,
      idUsuario_procesa: idUsuarioProcesa,

      // CONTRATOS A ACTUALIZAR COMISIÓN
      contratos: contratosActualizar,

      // CONTRATOS PENDIENTES (indexados)
      contador: pendientesContador,
      idContrato: pendientesIdContrato,
      id_emp: pendientesIdEmp,
      mes: pendientesMes,
      anio: pendientesAnio,
      idEstado_Contrato: pendientesIdEstadoContrato,
      porcentaje_comision: pendientesPorcentajeComision,
      valor_mensual: pendientesValorMensual,

      // CHARGEBACK (indexados)
      contador_charvag: charvaggContador,
      idContrato_charvag: charvaggIdContrato,
      id_emp_charvag: charvaggIdEmp,
      mes_charvag: charvaggMes,
      anio_charvag: charvaggAnio,
      idEstado_Contrato_charvag: charvaggIdEstadoContrato,
      valor_mensual_charvag: charvaggValorMensual
    };

    return jsonProcesamiento;
  };

  // Función para procesar reporte de comisiones
  const handleDescargarJson = async () => {
    try {
      setIsLoading(true);
      const jsonData = generarJsonProcesamiento();
      
      await procesarReporteComisionMutation.mutateAsync(jsonData);
      
      setError(""); // Limpiar errores
      setNotificacion({
        tipo: 'success',
        mensaje: 'Reporte de comisiones procesado exitosamente'
      });
      
      // Limpiar datos después del procesamiento exitoso
      setTimeout(() => {
        handleCleanFilter();
        setNotificacion(null);
      }, 2000);
    } catch (err: any) {
      const errorMsg = err?.response?.data?.message || err?.message || "Error al procesar reporte de comisiones";
      setError(errorMsg);
      setNotificacion({
        tipo: 'error',
        mensaje: errorMsg
      });
      console.error("Error al procesar reporte:", err);
    } finally {
      setIsLoading(false);
    }
  };

  // Exportar a Excel
  const handleExportExcel = async () => {
    // Si el checkbox está activo, ejecutar procesamiento
    if (confirmarProcesamiento) {
      await handleDescargarJson();
    }

    setIsExporting(true);
    setExportType("excel");
    setExportProgress(0);

    try {
      // Simulación de progreso
      setExportProgress(30);

      // Usar las MISMAS columnas que en la tabla
      const columns: ExportColumn[] = [
        { header: "#", key: "numero" },
        { header: "Estado", key: "estado_registro" },
        { header: "Vendedor", key: "tipo" },
        { header: "Perfil Vendedor", key: "vendedor" },
        { header: "Grupo de Ventas", key: "cargo" },
        { header: "Fecha Instalación", key: "fecha" },
        { header: "Subido el Contrato", key: "nombre_cliente" },
        { header: "No. Contrato", key: "ciudad" },
        { header: "Cliente", key: "sector" },
        { header: "# Documento", key: "coordenadas" },
        { header: "Sector", key: "tecnico" },
        { header: "Forma Pago", key: "forma_pago" },
        { header: "Buró de Crédito", key: "Banco" },
        { header: "Ciudad", key: "estado_venta" },
        { header: "Plan", key: "estado_instalacion" },
        { header: "Costo sin IVA/SEGURO", key: "nombre_plan_factura" },
        { header: "Servicio", key: "nombre_plan" },
        { header: "Estado Cliente", key: "tipo_plan" },
        { header: "Porcentaje Comisión", key: "valor_mensual" },
        { header: "Valor", key: "valor_instalacion" },
      ];

      setExportProgress(60);

      await new Promise(resolve => setTimeout(resolve, 500)); // Dar tiempo para mostrar progreso

      // Preparar resumen si existe
      const summary = resumenVendedor ? {
        total: filteredData.length,
        aprobadas: filteredData.filter(item => item.estado_registro === 'Activo').length,
        pendientes: filteredData.filter(item => item.estado_registro === 'Pendiente').length,
        total_comisiones: resumenVendedor.total_comisiones,
        chargeback: resumenVendedor.charvag,
        equifax: resumenVendedor.equifax,
        total_pagar: resumenVendedor.total_pagar,
        tasaConversion: '0'
      } : undefined;

      // Agregar números secuenciales a los datos
      const dataWithNumbers = filteredData.map((row, index) => ({
        ...row,
        numero: index + 1
      }));

      exportToExcel(dataWithNumbers, columns, { filters: exportFilters, summary });

      setExportProgress(100);

      // Esperar un momento antes de cerrar el modal
      await new Promise(resolve => setTimeout(resolve, 500));
    } catch (error) {
      console.error("Error al exportar Excel:", error);
      setError("Error al exportar a Excel");
    } finally {
      setIsExporting(false);
      setExportType("");
      setExportProgress(0);
    }
  };

  // Exportar Chargebacks a Excel
  const handleExportChargebacks = async () => {
    setIsExporting(true);
    setExportType("excel");
    setExportProgress(0);

    try {
      setExportProgress(30);

      // Definir columnas para la tabla de chargebacks
      const chargebackColumns: ExportColumn[] = [
        { header: "#", key: "numero" },
        { header: "Vendedor", key: "vendedor" },
        { header: "N° Contrato", key: "idContrato" },
        { header: "Cliente", key: "nombre_cliente" },
        { header: "Plan", key: "nombre_plan" },
        { header: "Costo", key: "valor" },
        { header: "Estado Contrato", key: "estado_contrato" },
        { header: "Tecnico Instalador", key: "nombre_tecnico" },
        { header: "Fecha de instalacion", key: "fecha_instalacion" },
        { header: "Fecha final", key: "fecha_final" },
        { header: "Motivo Retiro Agendado", key: "motivo" },
        { header: "Servicio", key: "tipo_servicio" },
        { header: "Tiempo transurido", key: "tiempo_transcurrido" },
        { header: "Ultimo Pago", key: "ultimo_pago" },
      ];

      setExportProgress(60);

      await new Promise(resolve => setTimeout(resolve, 500));

      // Agregar números secuenciales a los datos de chargeback
      const dataWithNumbers = detallesCharvag.map((row, index) => ({
        ...row,
        numero: index + 1
      }));

      setExportProgress(80);

      // Exportar datos
      exportToExcel(dataWithNumbers, chargebackColumns, {
        filename: `Detalle_Chargebacks_${format(new Date(), "yyyy-MM-dd_HH-mm")}.xlsx`,
        title: "DETALLE CHARGEBACK",
      });

      setExportProgress(100);

      // Esperar un momento antes de cerrar el modal
      await new Promise(resolve => setTimeout(resolve, 500));
    } catch (error) {
      console.error("Error al exportar chargebacks a Excel:", error);
      setError("Error al exportar chargebacks a Excel");
    } finally {
      setIsExporting(false);
      setExportType("");
      setExportProgress(0);
    }
  };

  return (
    <Grid container spacing={2.5}>

      {/* Notificaciones */}
      {notificacion && (
        <Grid item xs={12}>
          <Alert severity={notificacion.tipo} onClose={() => setNotificacion(null)}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {notificacion.mensaje}
            </Typography>
          </Alert>
        </Grid>
      )}

      {/* Error de rango de fechas */}
      {dateRangeError && (
        <Grid item xs={12}>
          <Alert severity="error" onClose={() => setDateRangeError("")}>
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              {dateRangeError}
            </Typography>
            <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
              Por favor, ajuste el rango de fechas a máximo 31 días.
            </Typography>
          </Alert>
        </Grid>
      )}

      {/* Indicador de carga */}
      {isLoading && (
        <Grid item xs={12}>
          <Box sx={{ width: "100%" }}>
            <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
              Cargando datos...
            </Typography>
            <LinearProgress />
          </Box>
        </Grid>
      )}

      {/* Filtros principales */}
      <Grid item xs={12}>
        <Grid container spacing={1.5}>
          {/* <Grid item xs={12} sm={6} md={4} lg={3}>
            <DateRangePicker
              size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              flatpickrRef={flatpickrRef}
              onChange={(range) => onChangeRangeDate(range)}
            />
          </Grid> */}
          <Grid item xs={12} sm={6} md={3} lg={2}>
            <MonthPicker
              size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
              flatpickrRef={flatpickrMonthRef}
              dayFixed={26}
              label="Desde"
              onChange={(value) => {
                console.log("MES DESDE:", value);
                setMesDesde(value);

                const siguienteMes = getNextMonth(value);
                console.log("MES HASTA AUTOMÁTICO:", siguienteMes);
                setMesHasta(siguienteMes);
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg={2}>
            <MonthPicker
              flatpickrRef={flatpickrHastaRef}
              dayFixed={25}
              label="Hasta"
              onChange={() => { }}
              customStyle={{
                pointerEvents: "none",
                opacity: 0.7,
              }}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Grupo Vendedor</InputLabel>
              <Select
                multiple={false}
                value={planFilter[0] || ""}
                onChange={async (e) => {
                  const value = e.target.value as string;
                  setPlanFilter(value ? [value] : []);
                  // Buscar empleados si hay grupo seleccionado
                  if (value) {
                    const grupo = grupoVendedorOptions.find(g => g.grupo_id === value);
                    if (grupo && grupo.cargos_ids && mesHasta) {
                      await fetchEmpleadosGrupo(grupo.cargos_ids, mesHasta);
                    } else {
                      setEmpleadosGrupo([]);
                    }
                  } else {
                    setEmpleadosGrupo([]);
                  }
                }}
                label="Grupo Vendedor"
                renderValue={(selected) => {
                  const grupo = grupoVendedorOptions.find(g => g.grupo_id === selected);
                  return grupo ? grupo.grupo : "";
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                    },
                  },
                }}
                disabled={isLoadingGrupos || grupoVendedorOptions.length === 0}
                IconComponent={isLoadingGrupos ? () => <CircularProgress size={20} sx={{ mr: 1 }} /> : undefined}
              >
                <Box sx={{ px: 1.5, py: 0.75, position: 'sticky', top: 0, bgcolor: 'background.paper', zIndex: 1 }}>
                  <TextField
                    size="small"
                    placeholder="Buscar grupo..."
                    fullWidth
                    value={searchGrupo}
                    onChange={(e) => setSearchGrupo(e.target.value)}
                    onKeyDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                  />
                </Box>
                {/* Loading indicator for grupos y manejo de error */}
                {isLoadingGrupos ? (
                  <MenuItem disabled dense>
                    <CircularProgress size={18} sx={{ mr: 1 }} /> Cargando grupos...
                  </MenuItem>
                ) : errorGrupos ? (
                  <MenuItem disabled dense>
                    <ListItemText primary="Error al cargar grupos" primaryTypographyProps={{ fontSize: '0.875rem', color: 'error.main' }} />
                  </MenuItem>
                ) : gruposFiltrados.length > 0 ? (
                  gruposFiltrados.map((grupo) => (
                    <MenuItem key={grupo.grupo_id} value={grupo.grupo_id} dense>
                      <ListItemText
                        primary={grupo.grupo}
                        primaryTypographyProps={{ fontSize: "0.875rem" }}
                      />
                    </MenuItem>
                  ))
                ) : (
                  <MenuItem disabled dense>
                    <ListItemText primary="No se encontraron grupos" primaryTypographyProps={{ fontSize: '0.875rem' }} />
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={3} lg={2}>
            <FormControl fullWidth size="small">
              <InputLabel>Vendedor</InputLabel>
              <Select
                multiple={false}
                value={canalFilter[0] || ""}
                onChange={(e) => {
                  const value = e.target.value as string;
                  setCanalFilter(value ? [value] : []);
                }}
                label="Vendedor"
                disabled={isLoadingEmpleados || empleadosGrupo.length === 0 || planFilter.length !== 1}
                IconComponent={isLoadingEmpleados ? () => <CircularProgress size={20} sx={{ mr: 1 }} /> : undefined}
                renderValue={(selected) => {
                  const emp = empleadosGrupo.find(e => String(e.id_emp) === selected);
                  return emp ? emp.nombre_emp : "";
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 300,
                    },
                  },
                }}
              >
                <Box sx={{ px: 1.5, py: 0.75, position: 'sticky', top: 0, bgcolor: 'background.paper', zIndex: 1 }}>
                  <TextField
                    size="small"
                    placeholder="Buscar vendedor..."
                    fullWidth
                    value={searchVendedor}
                    onChange={(e) => setSearchVendedor(e.target.value)}
                    onKeyDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                  />
                </Box>
                {isLoadingEmpleados ? (
                  <MenuItem disabled dense>
                    <CircularProgress size={18} sx={{ mr: 1 }} /> Cargando vendedores...
                  </MenuItem>
                ) : empleadosGrupo.length > 0 ? (
                  [
                    ...empleadosGrupo
                      .filter(emp => emp.es_principal === 1 && emp.nombre_emp.toLowerCase().includes(searchVendedor.toLowerCase()))
                      .map(emp => (
                        <MenuItem key={emp.id_emp} value={String(emp.id_emp)} dense>
                          <ListItemText
                            primary={
                              <span style={{
                                color: '#1976d2',
                                fontWeight: 700,
                                textDecoration: 'underline',
                                fontSize: '0.95em'
                              }}>
                                {emp.nombre_emp} (Supervisor)
                              </span>
                            }
                            secondary="Principal"
                            primaryTypographyProps={{ fontSize: '0.875rem' }}
                          />
                        </MenuItem>
                      )),
                    ...empleadosGrupo
                      .filter(emp => emp.es_principal !== 1 && emp.nombre_emp.toLowerCase().includes(searchVendedor.toLowerCase()))
                      .map(emp => (
                        <MenuItem key={emp.id_emp} value={String(emp.id_emp)} dense>
                          <ListItemText
                            primary={emp.nombre_emp}
                            primaryTypographyProps={{ fontSize: '0.875rem' }}
                          />
                        </MenuItem>
                      ))
                  ]
                ) : (
                  <MenuItem disabled dense>
                    <ListItemText primary="No se encontraron vendedores" primaryTypographyProps={{ fontSize: '0.875rem' }} />
                  </MenuItem>
                )}
              </Select>
            </FormControl>
          </Grid>

          {/* <Grid item xs={12} sm={6} md="auto" lg="auto" sx={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title="Recargar Canales">
              <IconButton
                color="primary"
                onClick={handleRefreshFiltros}
                disabled={isLoadingFiltros}
                size="small"
                sx={{
                  border: 1,
                  borderColor: 'primary.main',
                  '&:hover': {
                    bgcolor: 'primary.light',
                    borderColor: 'primary.dark'
                  },
                  '&.Mui-disabled': {
                    borderColor: 'action.disabled'
                  }
                }}
              >
                {isLoadingFiltros ? <CircularProgress size={20} /> : <Refresh />}
              </IconButton>
            </Tooltip>
          </Grid> */}
        </Grid>
      </Grid>

      {/* Botones de acción */}
      <Grid item xs={12}>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, gap: 1.5, alignItems: { xs: 'stretch', sm: 'center' } }}>
          <Button
            variant="contained"
            color="primary"
            size="medium"
            startIcon={<Search />}
            onClick={handleSearch}
            disabled={dateRangeError !== ""}
            sx={{
              flex: { xs: 1, sm: '0 1 auto' },
              minWidth: { xs: 'auto', sm: 140 },
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: 2,
              '&:hover': { boxShadow: 4 }
            }}
          >
            Consultar
          </Button>

          <Button
            variant="outlined"
            color="primary"
            size="medium"
            startIcon={<FilterAltOffIcon />}
            onClick={handleCleanFilter}
            sx={{
              flex: { xs: 1, sm: '0 1 auto' },
              minWidth: { xs: 'auto', sm: 140 },
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Limpiar Filtros
          </Button>

          <Box sx={{ flex: 1, display: { xs: 'none', sm: 'block' } }} />

          <Button
            variant="contained"
            color="success"
            size="medium"
            startIcon={<Description />}
            onClick={handleExportExcel}
            disabled={allData.length === 0}
            sx={{
              flex: { xs: 1, sm: '0 1 auto' },
              minWidth: { xs: 'auto', sm: 140 },
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: 2,
              '&:hover': { boxShadow: 4 }
            }}
          >
            Excel
          </Button>

          {/* <Button
            variant="contained"
            color="error"
            size="medium"
            startIcon={<PictureAsPdf />}
            onClick={handleExportPDF}
            disabled={allData.length === 0}
            sx={{
              flex: { xs: 1, sm: '0 1 auto' },
              minWidth: { xs: 'auto', sm: 140 },
              textTransform: 'none',
              fontWeight: 600,
              boxShadow: 2,
              '&:hover': { boxShadow: 4 }
            }}
          >
            PDF
          </Button> */}

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 0.75,
              px: 2,
              py: 1.5,
              borderRadius: 1,
              border: '2px solid',
              borderColor: confirmarProcesamiento ? '#9C27B0' : 'divider',
              bgcolor: confirmarProcesamiento ? 'rgba(156, 39, 176, 0.15)' : 'rgba(156, 39, 176, 0.05)',
              transition: 'all 0.3s ease',
              cursor: datosYaProcesados || allData.length === 0 ? 'not-allowed' : 'pointer',
              '&:hover': {
                borderColor: datosYaProcesados || allData.length === 0 ? 'divider' : '#9C27B0',
                bgcolor: datosYaProcesados || allData.length === 0 ? 'rgba(156, 39, 176, 0.05)' : 'rgba(156, 39, 176, 0.1)'
              }
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Checkbox
                checked={confirmarProcesamiento}
                onChange={(e) => setConfirmarProcesamiento(e.target.checked)}
                disabled={ allData.length === 0}
                sx={{
                  color: '#9C27B0',
                  '&.Mui-checked': {
                    color: '#9C27B0',
                  },
                }}
              />
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#9C27B0' }}>
                  Confirmar
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Grid>

      {/* Resumen de registros con labels diferenciados */}
      {!isLoading && allData.length > 0 && (
        <Grid item xs={12}>
          <Box sx={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 2,
            p: 2,
            bgcolor: 'background.paper',
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider'
          }}>
            {/* Total */}
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 2,
              py: 1,
              bgcolor: 'grey.100',
              borderRadius: 1
            }}>
              <Typography variant="body2" color="text.secondary">Total:</Typography>
              <Typography variant="h6" sx={{ fontWeight: 700 }}>{allData.length.toLocaleString()}</Typography>
            </Box>

            {/* Clientes Activos */}
            <Box
              onClick={() => setEstadoRegistroFilter(estadoRegistroFilter === 'Activo' ? 'todos' : 'Activo')}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 1,
                bgcolor: estadoRegistroFilter === 'Activo' ? 'success.main' : 'rgba(76, 175, 80, 0.15)',
                borderRadius: 1,
                cursor: 'pointer',
                transition: 'all 0.2s',
                border: '2px solid',
                borderColor: estadoRegistroFilter === 'Activo' ? 'success.dark' : 'transparent',
                '&:hover': {
                  bgcolor: estadoRegistroFilter === 'Activo' ? 'success.dark' : 'rgba(76, 175, 80, 0.25)',
                  transform: 'scale(1.02)'
                }
              }}
            >
              <Box sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                bgcolor: estadoRegistroFilter === 'Activo' ? 'white' : 'success.main'
              }} />
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: estadoRegistroFilter === 'Activo' ? 'white' : 'success.dark'
                }}
              >
                Clientes Activos
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: estadoRegistroFilter === 'Activo' ? 'white' : 'success.main'
                }}
              >
                {conteoEstados.activos.toLocaleString()}
              </Typography>
            </Box>

            {/* Pendientes de Revisión */}
            <Box
              onClick={() => setEstadoRegistroFilter(estadoRegistroFilter === 'Pendiente' ? 'todos' : 'Pendiente')}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                px: 2,
                py: 1,
                bgcolor: estadoRegistroFilter === 'Pendiente' ? 'warning.main' : 'rgba(255, 152, 0, 0.15)',
                borderRadius: 1,
                cursor: 'pointer',
                transition: 'all 0.2s',
                border: '2px solid',
                borderColor: estadoRegistroFilter === 'Pendiente' ? 'warning.dark' : 'transparent',
                '&:hover': {
                  bgcolor: estadoRegistroFilter === 'Pendiente' ? 'warning.dark' : 'rgba(255, 152, 0, 0.25)',
                  transform: 'scale(1.02)'
                }
              }}
            >
              <Box sx={{
                width: 12,
                height: 12,
                borderRadius: '50%',
                bgcolor: estadoRegistroFilter === 'Pendiente' ? 'white' : 'warning.main'
              }} />
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: estadoRegistroFilter === 'Pendiente' ? 'white' : 'warning.dark'
                }}
              >
                Pendientes de Revisión
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  color: estadoRegistroFilter === 'Pendiente' ? 'white' : 'warning.main'
                }}
              >
                {conteoEstados.pendientes.toLocaleString()}
              </Typography>
            </Box>

            {/* Indicador de filtro activo */}
            {estadoRegistroFilter !== 'todos' && (
              <Box sx={{ display: 'flex', alignItems: 'center', ml: 'auto' }}>
                <Typography variant="caption" color="text.secondary" sx={{ mr: 1 }}>
                  Filtrado: mostrando {filteredData.length} registros
                </Typography>
                <Button
                  size="small"
                  variant="text"
                  onClick={() => setEstadoRegistroFilter('todos')}
                  sx={{ textTransform: 'none', fontSize: '0.75rem' }}
                >
                  Ver todos
                </Button>
              </Box>
            )}
          </Box>
        </Grid>
      )}

      {/* Mensaje de datos ya procesados */}
      {datosYaProcesados && (
        <Grid item xs={12}>
          <Alert severity="success" onClose={() => setDatosYaProcesados(false)} sx={{
            bgcolor: 'rgba(76, 175, 80, 0.1)',
            borderLeft: '4px solid',
            borderColor: 'success.main'
          }}>
            <Typography variant="body2" sx={{ fontWeight: 700, color: 'success.main' }}>
              Los datos ya fueron procesados!
            </Typography>
          </Alert>
        </Grid>
      )}

      {/* Tabla */}
      <Grid item xs={12}>
        <GeneralTable
          columns={columnBase}
          data={paginatedData}
          isLoading={isLoading}
          pagination={pagination}
          onPaging={setPagination}
          rowCount={filteredData.length}
          enableColumnActions={false}
          enableEditing={false}
          enableGlobalFilter={false}
          enableColumnFilters={false}
          enableHoverEffect={true}
          paintRow={getRowBackgroundColor}
        />
      </Grid>

      {/* Resumen de Comisiones del Vendedor */}
      {resumenVendedor && !isLoading && (
        <Grid item xs={12} md={6} lg={4}>
          <TableContainer
            component={Paper}
            sx={{
              borderRadius: 2,
              boxShadow: 3,
              overflow: 'hidden'
            }}
          >
            <Table size="small">
              <TableBody>
                {/* TOTAL COMISION EN VENTAS */}
                <TableRow sx={{ bgcolor: '#1a2744' }}>
                  <TableCell sx={{
                    color: 'white',
                    fontWeight: 600,
                    borderBottom: '1px solid rgba(255,255,255,0.1)',
                    py: 1.5
                  }}>
                    TOTAL COMISION EN VENTAS
                  </TableCell>
                  <TableCell sx={{
                    color: 'white',
                    fontWeight: 700,
                    textAlign: 'right',
                    borderBottom: '1px solid rgba(255,255,255,0.1)',
                    py: 1.5
                  }}>
                    {resumenVendedor.total_comisiones.toLocaleString('es-EC', { minimumFractionDigits: 2 })}
                  </TableCell>
                </TableRow>

                {/* (+) TOTAL COMISION MES ANTERIOR - AHORA DINÁMICO */}
                {datosMeses.map((mesData, index) => (
                  <TableRow key={index} sx={{ bgcolor: '#1a2744' }}>
                    <TableCell sx={{
                      color: 'white',
                      fontWeight: 600,
                      borderBottom: '1px solid rgba(255,255,255,0.1)',
                      py: 1.5
                    }}>
                      {`(+)TOTAL COMISION EN VENTAS ${mesData.mes}`}
                    </TableCell>
                    <TableCell sx={{
                      color: 'white',
                      fontWeight: 700,
                      textAlign: 'right',
                      borderBottom: '1px solid rgba(255,255,255,0.1)',
                      py: 1.5
                    }}>
                      {mesData.total.toLocaleString('es-EC', { minimumFractionDigits: 2 })}
                    </TableCell>
                  </TableRow>
                ))}


                {/* (-) CHARGEBACK con botón */}
                <TableRow sx={{ bgcolor: '#243554' }}>
                  <TableCell sx={{
                    color: 'white',
                    fontWeight: 600,
                    borderBottom: '1px solid rgba(255,255,255,0.1)',
                    py: 1
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      (-)CHARGEBACK
                      <IconButton
                        size="small"
                        onClick={() => setOpenChargebackModal(true)}
                        sx={{
                          bgcolor: '#2196f3',
                          color: 'white',
                          '&:hover': { bgcolor: '#1976d2' },
                          p: 0.5,
                          ml: 0.5
                        }}
                      >
                        <SearchOutlined fontSize="small" />
                      </IconButton>
                    </Box>
                  </TableCell>
                  <TableCell sx={{
                    color: 'white',
                    fontWeight: 700,
                    textAlign: 'right',
                    borderBottom: '1px solid rgba(255,255,255,0.1)',
                    py: 1
                  }}>
                    {resumenVendedor.charvag.toLocaleString('es-EC', { minimumFractionDigits: 2 })}
                  </TableCell>
                </TableRow>

                {/* (-) EQUIFAX */}
                <TableRow sx={{ bgcolor: '#1a2744' }}>
                  <TableCell sx={{
                    color: 'white',
                    fontWeight: 600,
                    borderBottom: '1px solid rgba(255,255,255,0.1)',
                    py: 1.5
                  }}>
                    (-)EQUIFAX
                  </TableCell>
                  <TableCell sx={{
                    color: 'white',
                    fontWeight: 700,
                    textAlign: 'right',
                    borderBottom: '1px solid rgba(255,255,255,0.1)',
                    py: 1.5
                  }}>
                    {resumenVendedor.equifax.toLocaleString('es-EC', { minimumFractionDigits: 2 })}
                  </TableCell>
                </TableRow>

                {/* TOTAL A PAGAR */}
                <TableRow sx={{ bgcolor: '#1a2744' }}>
                  <TableCell sx={{
                    color: 'white',
                    fontWeight: 700,
                    py: 1.5,
                    borderBottom: 'none'
                  }}>
                    TOTAL A PAGAR
                  </TableCell>
                  <TableCell sx={{
                    color: 'white',
                    fontWeight: 700,
                    textAlign: 'right',
                    py: 1.5,
                    borderBottom: 'none'
                  }}>
                    {resumenVendedor.total_pagar.toLocaleString('es-EC', { minimumFractionDigits: 2 })}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      )}

      {/* Modal de Detalle CHARGEBACK */}
      <Dialog
        open={openChargebackModal}
        onClose={() => setOpenChargebackModal(false)}
        maxWidth="xl"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            maxHeight: '90vh'
          }
        }}
      >
        <DialogTitle sx={{
          textAlign: 'center',
          fontWeight: 700,
          fontSize: '1.25rem',
          borderBottom: '1px solid',
          borderColor: 'divider'
        }}>
          DETALLE CHARGEBACK
        </DialogTitle>
        <DialogContent sx={{ p: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, mt: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Button
                variant="contained"
                color="success"
                size="small"
                startIcon={<Description />}
                sx={{ textTransform: 'none' }}
                onClick={handleExportChargebacks}
                disabled={isExporting || detallesCharvag.length === 0}
              >
                Excel
              </Button>
              <Typography variant="body2" color="text.secondary">
                Mostrar
              </Typography>
              <Select
                size="small"
                defaultValue={5}
                sx={{ minWidth: 70 }}
              >
                <MenuItem value={5}>5</MenuItem>
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={25}>25</MenuItem>
                <MenuItem value={50}>50</MenuItem>
              </Select>
              <Typography variant="body2" color="text.secondary">
                registros
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" color="text.secondary">Filtro</Typography>
              <TextField size="small" variant="outlined" sx={{ width: 150 }} />
            </Box>
          </Box>

          <TableContainer component={Paper} sx={{ maxHeight: 500 }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Vendedor</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>N° Contrato</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Cliente</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Plan</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Costo</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Estado Contrato</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Tecnico Instalador</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Fecha de instalacion</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Fecha final</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Motivo Retiro Agendado</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Servicio</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Tiempo transurido</TableCell>
                  <TableCell sx={{ fontWeight: 700, bgcolor: 'grey.100', whiteSpace: 'nowrap' }}>Ultimo Pago</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {detallesCharvag.map((detalle, index) => (
                  <TableRow
                    key={detalle.idContrato || index}
                    sx={{
                      '&:nth-of-type(odd)': { bgcolor: 'rgba(0, 0, 0, 0.02)' },
                      '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.04)' }
                    }}
                  >
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.vendedor || detalle.nombre_emp || resumenVendedor?.nombre_vendedor || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.idContrato || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.nombre_cliente || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.nombre_plan || detalle.plan || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.valor || detalle.valor_mensual || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.estado_contrato || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.nombre_tecnico || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.fecha_instalacion || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.fecha_final || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.motivo || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.tipo_servicio || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.tiempo_transcurrido || '-'}</TableCell>
                    <TableCell sx={{ whiteSpace: 'nowrap' }}>{detalle.ultimo_pago || '-'}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
            <Typography variant="body2" color="text.secondary">
              Registros del 1 al {Math.min(5, detallesCharvag.length)} de un total de {detallesCharvag.length}
            </Typography>
          </Box>
        </DialogContent>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', p: 2, borderTop: '1px solid', borderColor: 'divider' }}>
          <Button
            variant="outlined"
            onClick={() => setOpenChargebackModal(false)}
            sx={{ textTransform: 'none' }}
          >
            Cerrar
          </Button>
        </Box>
      </Dialog>

      {/* Modal de progreso de exportación */}
      <Dialog
        open={isExporting}
        disableEscapeKeyDown
        PaperProps={{
          sx: {
            minWidth: 400,
            borderRadius: 2,
          }
        }}
      >
        <DialogTitle sx={{ textAlign: 'center', pb: 2 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 1 }}>
            {exportType === "excel" ? (
              <Description sx={{ fontSize: 48, color: 'success.main' }} />
            ) : (
              <PictureAsPdf sx={{ fontSize: 48, color: 'error.main' }} />
            )}
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Exportando {exportType === "excel" ? "Excel" : "PDF"}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent sx={{ pb: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <CircularProgress size={24} />
              <Typography variant="body2" color="text.secondary">
                {exportProgress < 50 ? "Preparando datos..." :
                  exportProgress < 80 ? "Generando archivo..." :
                    "Finalizando descarga..."}
              </Typography>
            </Box>
            <LinearProgress
              variant="determinate"
              value={exportProgress}
              sx={{ height: 8, borderRadius: 4 }}
            />
            <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center' }}>
              {exportProgress}% completado
            </Typography>
            <Typography variant="caption" color="text.secondary" sx={{ textAlign: 'center', mt: 1 }}>
              Por favor espere, esto puede tomar unos segundos...
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    </Grid>
  );
}
